var map = {
	"./backgroundPulse-sm.ff064d7d.jpg": 3620,
	"./coinbase.svg": 9462,
	"./imtoken.svg": 278,
	"./logo.726505f2.svg": 1072,
	"./walletconnect.png": 4264,
	"./walletconnect.svg": 1219,
	"./wallets/aave.jpg": 4046,
	"./wallets/aktionariat.png": 5849,
	"./wallets/atomic.jpeg": 8501,
	"./wallets/atwallet.png": 8097,
	"./wallets/authereum.png": 1365,
	"./wallets/binance.png": 8963,
	"./wallets/bitkeep.png": 7206,
	"./wallets/bitpay.jpeg": 9660,
	"./wallets/bnb.png": 3681,
	"./wallets/coin98.jpeg": 8590,
	"./wallets/coinb.png": 491,
	"./wallets/defiat.jpg": 8290,
	"./wallets/digitex.png": 2851,
	"./wallets/enjin.jpg": 1529,
	"./wallets/ethereum-classic.png": 8162,
	"./wallets/exodus.jpg": 8380,
	"./wallets/flare.jpg": 1052,
	"./wallets/icon.png": 5050,
	"./wallets/iotex.png": 8343,
	"./wallets/kin.png": 7291,
	"./wallets/ledger.png": 5506,
	"./wallets/loggoo.png": 7707,
	"./wallets/math-wallet.png": 2399,
	"./wallets/meta.jpeg": 6819,
	"./wallets/mew.png": 5522,
	"./wallets/nano.png": 9226,
	"./wallets/oxen.png": 9162,
	"./wallets/portis.png": 6059,
	"./wallets/safepall.png": 9036,
	"./wallets/scatter.jpg": 4025,
	"./wallets/skale.png": 9534,
	"./wallets/squarelink.png": 6567,
	"./wallets/terra.png": 8041,
	"./wallets/theta.png": 8930,
	"./wallets/tomo.png": 262,
	"./wallets/trezor.png": 937,
	"./wallets/tron.png": 985,
	"./wallets/trust.jpeg": 8509,
	"./wallets/vechain.jpg": 8300,
	"./wallets/wanchain.png": 5316,
	"./wallets/xrp.png": 3538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;